import Echart from "echarts-for-react"
import { langStore } from "../../../../stores/lang-store"
import { dougnutBundle } from "./half-doughnut-const"

const HalfDoughnutChart = ({ title, data, unit = "가구" }) => {
  const { lang } = langStore()

  const option = {
    tooltip: {
      trigger: "item",
      formatter: (p) => {
        if (!p) return ""
        return `
          <b>${p.name}</b><br/>
          ${dougnutBundle.tooltip.rate[lang]}: ${p.percent?.toFixed(2)}%<br/>
          ${dougnutBundle.tooltip.value[lang]}: ${p.value} ${unit}
        `
      },
      backgroundColor: "rgba(0,0,0,0.75)",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 13
      }
    },
    title: {
      text: title,
      left: "center",
      top: "50%", // 반원 중앙쯤
      textStyle: {
        fontSize: 20,
        fontWeight: 600,
        color: "#333"
      }
    },
    series: [
      {
        type: "pie",
        startAngle: 180,
        endAngle: 0,
        radius: ["50%", "110%"], // innerSize / size 대응
        center: ["50%", "60%"],
        itemStyle: {
          color: (p) => p.data.bg
        },
        label: {
          show: true,
          position: "inside",
          formatter: (p) => p.name,
          fontSize: 14,
          fontWeight: "bold",
          color: "#fff"
        },
        data
      }
    ]
  }

  return (
    <div className="aspect-video h-45">
      <Echart option={option} style={{ width: "100%", height: "280px" }} notMerge />
    </div>
  )
}

export default HalfDoughnutChart
